module.exports = __webpack_public_path__ + "media/mapsearch.89393e98.wav";